/**
 * Módulo de usuarios — CRUD completo con lista para selects de asignación
 */

import { createCrudMethods } from '../base/crudMethods';

/**
 * Crea el módulo de usuarios
 *
 * @param {Object} deps - Dependencias inyectadas
 * @param {Function} deps.authenticatedRequest - Función de request autenticada
 * @returns {Object} Métodos del módulo usuarios
 */
export function createUsuariosModule({ authenticatedRequest }) {
  return {
    ...createCrudMethods(
      {
        endpoint: '/api/usuarios',
        entityName: 'usuario',
        entityNamePlural: 'usuarios',
        methods: { lista: true }
      },
      { authenticatedRequest }
    )
  };
}
